
import { Dossier } from "@/models/dossier";
import { CompanyDossierService, CompanyService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			input: "",
			focused: false,
			fetchedItems: [] as {ID:number, Name:string, CompanyID:number}[]
		};
	},
	props: {
		value: {
			type: Object as ()=>Dossier
		},
		fancy: Boolean,
		label: String,
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				if (!this.focused && this.value){
					this.input = this.dossierToString(this.value.id, this.value.name);
				}
			}
		}
	},
	methods: {
		onFocus(){
			this.input = "";
			this.focused = true;
		},
		onBlur(){
			this.focused = false;
			this.input = "";
			if (this.value){
				this.input =this.dossierToString(this.value.id, this.value.name);
			}
		},
		dossierToString(id:number,name:string):string {
			return `${name} (${id})`;
		},
		onInput(event:string){
			this.input = event;
			this.doSearch();
		},
		async doSearch(){
			if (!this.focused) return;
			let input = this.input;
			let dossiers = await CompanyService.searchDossiers(this.input);
			if (this.input != input){
				return;
			}
			this.fetchedItems = dossiers;
		},
		async onDossierClick(item:{ID:number, CompanyID:number}){
			let dossier = await CompanyDossierService.getDossier(item.CompanyID, item.ID);
			let company = await CompanyService.getCompany(item.CompanyID);
			dossier.company = company;
			this.$emit("input", dossier);
			this.input = this.dossierToString(dossier.id, dossier.name);
		}
	}
});
